import { CLEAR_SELECTED_TRANSACTION, RESET_TRANSACTIONS, RESET_TRANSACTIONS_LOADED_TIMESTAMP, RESET_TRANSACTIONS_UPDATED_TIMESTAMP, SELECT_TRANSACTION, SET_ACCOUNTING_TRANSACTIONS_COUNT, SET_TRANSACTIONS_LOADING } from '@Actions/transactionsActions';
export const defaultState = {
    selectedTransaction: null,
    transactionsLoading: false,
    lastTransactionsLoadedTimestamp: new Date(),
    lastTransactionsUpdatedTimestamp: new Date(),
    accountingCounts: { count: 0, rows: [], amountSum: 0 }
};
export function transactionsReducer(state = defaultState, action) {
    switch (action.type) {
        case SET_TRANSACTIONS_LOADING:
            return Object.assign(Object.assign({}, state), { transactionsLoading: action.payload });
        case RESET_TRANSACTIONS_LOADED_TIMESTAMP: {
            return Object.assign(Object.assign({}, state), { lastTransactionsLoadedTimestamp: new Date() });
        }
        case RESET_TRANSACTIONS_UPDATED_TIMESTAMP: {
            return Object.assign(Object.assign({}, state), { lastTransactionsUpdatedTimestamp: new Date() });
        }
        case RESET_TRANSACTIONS: {
            return Object.assign(Object.assign({}, defaultState), { lastTransactionsLoadedTimestamp: state.lastTransactionsLoadedTimestamp, lastTransactionsUpdatedTimestamp: state.lastTransactionsUpdatedTimestamp });
        }
        case SELECT_TRANSACTION: {
            return Object.assign(Object.assign({}, state), { selectedTransaction: action.payload });
        }
        case CLEAR_SELECTED_TRANSACTION: {
            return Object.assign(Object.assign({}, state), { selectedTransaction: null });
        }
        case SET_ACCOUNTING_TRANSACTIONS_COUNT: {
            return Object.assign(Object.assign({}, state), { accountingCounts: action.payload });
        }
        default:
            return state;
    }
}
